import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '955936987240470';
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    const w = window as any;
    // If fbq already exists, just track another PageView and bail.
    if (w.fbq) {
      try {
        w.fbq('track', 'PageView');
      } catch {
        /* noop */
      }
      return;
    }
    // Initialize the fbq stub exactly as Meta's snippet does, but without
    // relying on getElementsByTagName('script')[0] (which can be undefined
    // in some sandboxed/iframe environments and crash).
    const n: any = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    w.fbq = n;
    if (!w._fbq) w._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    // Load fbevents.js by appending a script to <head> (robust fallback to <body>).
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const target = document.head || document.body;
    if (target) {
      target.appendChild(script);
    }
    // Init + initial PageView
    try {
      w.fbq('init', PIXEL_ID);
      w.fbq('track', 'PageView');
    } catch {
      /* noop */
    }
    // Inject the <noscript> fallback pixel image
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    if (document.body) {
      document.body.appendChild(noscript);
    }
    return () => {
      if (noscript.parentNode) noscript.parentNode.removeChild(noscript);
    };
  }, []);
  return null;
}